import React, { Fragment } from 'react';
import NavbarContainer from 'shared/containers/NavbarContainer';
import LoginContainer from 'bundles/LoginRegister/containers/LoginContainer';

const LoginScene = (props) => {
    return (
        <Fragment>
            <NavbarContainer />
            <LoginContainer {...props} />
        </Fragment>
    );
};

export default LoginScene;
